import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-user-affiliate-total-commission-card',
  templateUrl: './user-affiliate-total-commission-card.component.html',
  styleUrls: ['./user-affiliate-total-commission-card.component.scss'],
})
export class UserAffiliateTotalCommissionCardComponent {
  @Input() data: any;
}
